import React from 'react';
import PropTypes from 'prop-types';
import { propOr } from 'ramda';

import DroppableArea from '../droppableArea';
import './style.sass';

const ColumnBoard = ({
  agenda, statusId, isDragging, updateDroppable,
}) => (
  <div className="column-board">
    <div className="column-board__header">
      <h2 className="column-board__title">
        {agenda.title}
      </h2>
    </div>
    <DroppableArea
      tasks={propOr([], 'tasks', agenda)}
      statusId={statusId}
      isDragging={isDragging}
      updateDroppable={updateDroppable}
    />
  </div>
);

ColumnBoard.propTypes = {
  agenda: PropTypes.instanceOf(Object).isRequired,
  statusId: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  updateDroppable: PropTypes.number,
};

ColumnBoard.defaultProps = {
  updateDroppable: null,
};

export default ColumnBoard;
